import { useEffect, useState } from 'react';

const Signup = () => {
    const [showModal, setShowModal] = useState(false);
    const isFromCollection = window.location.pathname.includes('/collection');
    const redirectToParameter = new URLSearchParams(window.location.search).get('redirectTo');
    const routeAfterSignin = redirectToParameter || window.location.href;
    const locale = document.documentElement.lang || 'en';

    useEffect(() => {
        const handleOpenSignup = () => {
            setShowModal(true);
        };
        document.addEventListener('open_signup_popup', handleOpenSignup);

        return () => {
            document.removeEventListener('open_signup_popup', handleOpenSignup);
        };
    }, []);

    useEffect(() => {
        if (showModal) {
            const routeAuth0 = routeAfterSignin.includes('collection')
                ? `/auth/${locale}/collection/signup`
                : `/auth/${locale}/signup`;

            window.location.href = routeAuth0;
        }

        return null;
    }, [showModal, routeAfterSignin, locale, isFromCollection]);
};

export default Signup;
